// SPDX-FileCopyrightText: © 2024 Schneider Electric
//
// SPDX-License-Identifier: Apache-2.0

interface Request {
  ok: boolean
  data: string
}

interface IconRequestOk {
  ok: true
  data: string
}

interface IconRequestError {
  ok: false
  data: undefined
}

type IconRequest = IconRequestError | IconRequestOk

interface IconRequestUnknown {
  ok: boolean
  data?: string
}

const request = async (source: string): Promise<Request> => {
  const response = await fetch(source, { mode: 'cors' })
  return {
    ok: response.ok,
    data: await response.text(),
  }
}

const cachedIconRequests = new Map<string, IconRequest>()

const requestIcon = async (url: string): Promise<IconRequest> => {
  const cachedIconRequest = cachedIconRequests.get(url)
  if (cachedIconRequest) return cachedIconRequest

  const fileData = await request(url)
  const iconFileData: IconRequestUnknown = {
    ok: fileData.ok,
  }
  if (fileData.ok) {
    const div = document.createElement('div')
    div.innerHTML = fileData.data
    const child = div.firstElementChild
    iconFileData.data =
      child?.tagName.toLowerCase() === 'svg' ? child.outerHTML : ''
  }

  cachedIconRequests.set(url, iconFileData as IconRequest)
  return iconFileData as IconRequest
}

export default requestIcon
